import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import AuthLayout from '../../components/layouts/auth_layout'
import MainBackground from '../../images/main_bg.png'
import FlatButton from '../../components/buttons/flat_button'

const RegisterCompletePage: FC = () => {
  return (
    <AuthLayout>
      <div
        className="fixed inset-0 bg-cover bg-center bg-no-repeat z-[-1]"
        style={{
          backgroundImage: `url(${MainBackground})`,
        }}
      />
      <div className="w-full overflow-auto py-24 px-4">
        <div className="flex justify-center">
          <div className="max-w-[640px] bg-white rounded-xl md:px-6 px-2 py-8">
            <h1 className="text-2xl font-bold text-center mb-8">
              会員登録申請完了
            </h1>
            <div className="pb-4">
              <p>
                会員登録申請が完了しました。
                <br />
                この度はSDGs 共創
                Lodgeに企業・団体登録をお申し込みくださいまして、誠にありがとうございます。
                <br />
                お客様の入力いただいた情報をもとに登録審査を行なわせていただきます。
                <br />
                <br />
                審査の結果につきましては、1〜3営業日以内にメールにてご案内いたしますので、しばらくお待ちくださいますようお願いいたします。
                <br />
                ご入力いただいたメールアドレス宛に自動返信メールを送信しております。ご確認ください。
                <br />
                <br />
                また、ドメイン指定をされている場合は、「info@sdgs-lodges.jp」からのメールが受信できるようあらかじめ設定をお願いいたします。
              </p>
            </div>
            <div className="mb-8">
              <p>
                ご入力いただきました内容を確認後、担当者よりご連絡させていただきます。
              </p>
              <p>
                お急ぎのご連絡やご不明点などございましたら、
                <Link
                  target="_blank"
                  to="/contact"
                  className="text-main-blue"
                  rel="noreferrer"
                >
                  こちら
                </Link>
                からご連絡ください。
              </p>
            </div>
            <Link to="/login">
              <FlatButton className="w-full">ログインページへ戻る</FlatButton>
            </Link>
          </div>
        </div>
      </div>
    </AuthLayout>
  )
}

export default RegisterCompletePage
